import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import CommerceOnly from '/src/_includes/commerce-only.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <CommerceOnly mdxType="CommerceOnly" />
    <h1 {...{
      "id": "negotiable-quote-b2b-mutations"
    }}>{`Negotiable quote (B2B) mutations`}</h1>
    <p>{`The B2B negotiable quote mutations allow you to perform the following operations:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Manage the status of a negotiable quote`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "./request.md"
            }}>{`Request a negotiable quote`}</a>{` on behalf of a customer`}</li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "./send-for-review.md"
            }}>{`Send a negotiable quote for review`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "./close.md"
            }}>{`Close negotiable quotes`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "./delete.md"
            }}>{`Delete negotiable quotes`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Manage the contents of a negotiable quote`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "update-quantities.md"
            }}>{`Update the quantity of items`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "remove-items.md"
            }}>{`Completely remove items`}</a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Prepare the negotiable quote for processing`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "set-billing-address.md"
            }}>{`Set the billing address`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "set-shipping-address.md"
            }}>{`Set the shipping address`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "set-shipping-methods.md"
            }}>{`Set the shipping method`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "set-payment-method.md"
            }}>{`Set the payment method`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "place-order.md"
            }}>{`Place the order`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      